import { render, staticRenderFns } from "./publicClassDetail.vue?vue&type=template&id=4467b106&scoped=true"
import script from "./publicClassDetail.vue?vue&type=script&lang=js"
export * from "./publicClassDetail.vue?vue&type=script&lang=js"
import style0 from "./publicClassDetail.vue?vue&type=style&index=0&id=4467b106&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4467b106",
  null
  
)

export default component.exports